"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceMapMode = void 0;
const Utils_1 = require("../../utils/Utils");
exports.SourceMapMode = Utils_1.Utils.makeEnum({
    Inline: 'inline',
    Separate: 'separate'
});
